import React, { useState } from "react";
import {  Link } from "react-router-dom";


const ChapterDetails = ({ selectedChapter }) => {
  const authToken = localStorage.getItem("token");

    const [chapterData, setChapterData] = useState(selectedChapter);
    


  return (
     <>    
   
    <div className="col-md-8">
       <h1>{chapterData.chapter_name || ""}</h1>
       <div dangerouslySetInnerHTML={{ __html: chapterData.description }} />
       {chapterData.media_type==='Image' && chapterData.image_url && (
                    <div className="text-center">                       
                        <img src={chapterData.image_url} alt="Cover Preview"  className="img-fluid" />                        
                    </div>
                )}     
                 {chapterData.media_type==='Video' && chapterData.image_url && (
                    <div className="text-center mt-2">   
                    <video width="auto" style={{maxWidth:"100%"}} height="360" controls controlsList="nodownload">
                    <source src={chapterData.image_url} type="video/mp4" /> 
                    </video>              
                                              
                    </div>
                )}     
    </div>
    </>   
  );
};

export default ChapterDetails;
